export const FORM_INITIATED = 'form/initiated';

export const UPDATE_FORM_CONTROLLER_VALUE = 'form/form control value updated';

export const ADD_FORM_CONTROLLERS_TO_REPEATABLE_CONTROLLER =
    'form/added new controllers to the repeatable controller';

export const UPDATE_FORM_CONTROLLERS_IN_REPEATABLE_CONTROLLER =
    'form/updated controllers in the repeatable controller';

export const VALIDATE_LENDER_AMOUNTS = 'form/validating lender amounts';

export const VALIDATE_FORM_DATA = 'form/validating form data';

export const RESET_FORM_DATA_VALUES = 'form/reset form data values';

export const RESET_FORM_CONTROLS_STATE = 'form/reset form controls state';

export const SET_FORM_ERRORS = 'form/set form errors';

// export const SET_CALCULATOR_VALUES = 'form/set calculator values';

export const PREPARE_FORM_DATA_IF_VALID = 'form/prepare form data if valid';

export const UPDATE_CONTROL_STATE = 'form/update control state';

export const SET_FORM_STEP = 'form/set form step';

export const MERGE_FORM_STATE = 'form/merge form state';

export const CREATE_FORM_STATE_SNAPSHOT = 'form/create form state snapshot';

export const UPDATE_PROGRESS = 'form/update progress';
